<script setup lang="ts">
import { computed } from 'vue';
import { NConfigProvider, darkTheme } from 'naive-ui';
import { naiveThemeOverrides } from '@/styles/tokens';

/**
 * naive-ui's theme is derived from styles/tokens.css at runtime rather than
 * restated here — see styles/tokens.ts for why. Computed once: the stylesheets
 * are imported by main.ts before the app mounts, so the custom properties are
 * already resolvable by the time setup runs.
 */
const themeOverrides = computed(() => naiveThemeOverrides());
</script>

<template>
  <NConfigProvider :theme="darkTheme" :theme-overrides="themeOverrides">
    <RouterView />
  </NConfigProvider>
</template>
